module.exports = __webpack_public_path__ + "7819b4c3bd063cd406e377ae3dd5ed66.pdf";